import {useEffect} from 'react';

export function useEditorPrefetchMediaMobileModules(): void {
  useEffect((): void => {
    void prefetchDefaultModules();
  }, []);

  const prefetchDefaultModules = async (): Promise<void> => {
    await import(/* webpackPrefetch: true */ '@Panels/cropper-panel');
    await import(/* webpackPrefetch: true */ '@Panels/masking-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-filters-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-adjustments-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-effects-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-slideshow-slides-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-add-slide-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-alignment-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-slideshow-transition-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-slideshow-apply-properties-panel');
    await import(/* webpackPrefetch: true */ '@Panels/trim-panels/trim-video-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-drawing-color-panel');
    await import(/* webpackPrefetch: true */ '@Panels/replace-media-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-roundness-effect-panel');
  };
}
